import React from "react";
import { Box, styled } from "@mui/material";

// Define the keyframes using a string template
const loaderAnimation = {
  "0%": { transform: "rotate(0deg)" },
  "50%": { transform: "rotateY(180deg)" },
  "100%": { transform: "rotateX(180deg)" },
};

const LoaderContainer = styled(Box)({
  position: "relative",
  width: "70px",
  height: "70px",
});

const LargeSquare = styled(Box)({
  position: "absolute",
  inset: 0,
  margin: "auto",
  width: "100%",
  height: "100%",
  backgroundColor: "#e9e9ff",
  borderRadius: "10px",
  animation: "loading 2s infinite",
  "@keyframes loading": loaderAnimation,
});

const SmallSquare = styled(Box)({
  position: "absolute",
  width: "50%",
  height: "50%",
  inset: 0,
  margin: "auto",
  backgroundColor: "#6366F1",
  zIndex: 2,
  borderRadius: "6px",
  animation: "loading 2s infinite reverse",
  "@keyframes loading": loaderAnimation,
});

const CustomLoader = () => {
  return (
    <Box>
      <LoaderContainer>
        <SmallSquare />
        <LargeSquare />
      </LoaderContainer>
    </Box>
  );
};

export default CustomLoader;
